import { ENABLE_I18N } from '@src/config/env'
import type { TCountry } from '@src/config/localisation/locale-config.types'
import isBrowser from '@src/quince-site-common/src/utils/isBrowser'

export const isCountryCanada = (country: TCountry) => country.toLowerCase() === 'ca'
export const isCountryUS = (country: TCountry) => country.toLowerCase() === 'us'

export const getBFFApiVersion = (isI18nPreviewEnabled: boolean, apiVersion?: string) => {
  if (apiVersion === 'v3') {
    return 'v3'
  }
  if (isI18nPreviewEnabled) {
    return 'v2'
  } else {
    return 'v1'
  }
}

export function shouldEnableI18nServer(): boolean {
  return ENABLE_I18N
}

export function shouldEnableI18nClient(): boolean {
  if (!isBrowser()) return false
  return ENABLE_I18N
}
